<template>
  <div id="map-section" class="home-map-section" v-if="!isLoading">
    <ShipSection
      :ships="assets"
      :showBaseMapOptions="false"
      @ship-expanded="handleShipExpanded"
      @toggle-trail="handleTrailToggle"
      @trail-range="handleTrailRange"
      @zoom-to-ship="zoomToShip"
      @toggle-visibility="handleVisibilityToggle"
      @show-all-ships="handleShowAll"
      @hide-all-ships="handleHideAll"
      @set-base-layer="handleSetBaseLayer"
      @set-icon-style="handleSetIconStyle"
      @set-icon-scale="handleSetIconScale"
      @toggle-landmarks="handleToggleLandmarks"
      @toggle-timezones="handleToggleTimezones"
      @toggle-collapse="handleSidebarCollapse"
    />
    <div class="home-map-wrapper">
      <Map
        ref="mapView"
        :ships="assets"
        SelectedMap="windy"
        :hideSettingsControl="true"
        :sidebarVisible="sidebarVisible"
      />
    </div>
  </div>
  <div class="text-center text-danger my-2" v-else>
    <b-spinner class="align-middle"></b-spinner>
    <strong>Loading...</strong>
  </div>
</template>

<script>
import Map from '@/views/map';
import ShipSection from '@/views/home/components/ShipSection';
import { mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Map,
    ShipSection,
  },
  data() {
    return {
      isLoading: true,
      sidebarVisible: true,
    };
  },
  computed: {
    ...mapState('asset', {
      assets: (state) => state.assets.filter((asset) => asset.lastGpsData),
    }),
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('asset/fetchAndReconcileAssets');
    },
    zoomToShip(ship) {
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc && ship.lastLatLng) svc.panToShip(ship);
    },
    async handleTrailToggle(payload) {
      const ship = this.assets.find((s) => s.massId === payload.massId);
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (!ship || !svc) return;
      // Pas nyalain, paksa refetch biar window-nya ngikut chip yg lagi dipilih.
      await svc.toggleTrail(payload.trail, ship, payload.days || 1, payload.trail === true);
    },
    async handleTrailRange(payload) {
      const ship = this.assets.find((s) => s.massId === payload.massId);
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (!ship || !svc) return;
      await svc.toggleTrail(true, ship, payload.days || 1, true);
    },
    handleVisibilityToggle(payload) {
      this.$store.dispatch('asset/updateAssetVisibility', payload);
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.toggleShipVisibility(payload.massId, payload.isVisible);
    },
    handleShowAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', true);
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.showAllShips();
    },
    handleHideAll() {
      this.$store.dispatch('asset/setAllAssetsVisibility', false);
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.hideAllShips();
    },
    handleSetBaseLayer() {
      // Base map di halaman ini punya Windy; pilihannya disembunyiin di sidebar.
    },
    handleSetIconStyle(style) {
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.setIconStyle(style);
    },
    handleSetIconScale(scale) {
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.setIconScale(scale);
    },
    handleToggleLandmarks(visible) {
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.toggleLandmarks(visible);
    },
    handleToggleTimezones(visible) {
      const svc = this.$refs.mapView && this.$refs.mapView.mapService;
      if (svc) svc.toggleTimezones(visible);
    },
    handleShipExpanded({ massId }) {
      const ship = this.assets.find((s) => s.massId === massId);
      if (ship && this.$refs.mapView) this.$refs.mapView.ensureShipSummary(ship);
    },
    handleSidebarCollapse(isCollapsed) {
      this.sidebarVisible = !isCollapsed;
    },
  },
  async mounted() {
    try {
      await this.fetchData();
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style scoped>
.home-map-section {
  position: relative;
  display: flex;
  height: calc(100vh - 70px);
  width: 100%;
  overflow: hidden;
}

.home-map-wrapper {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
}
</style>
